<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalDuplicateMenuset"
      id="show-modal-duplicate-menuset"
    ></material-button>
    <material-button
      class="d-none"
      data-bs-dismiss="modal"
      data-bs-target="#modalDuplicateMenuset"
      id="hide-modal-duplicate-menuset"
    ></material-button>

    <div
      class="modal fade"
      id="modalDuplicateMenuset"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Duplicate Menuset</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              @click="closeModal()"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="w-100 mb-3">
              <label class="fw-bold" for="">Copy from</label>
              <div class="source-name">{{ menusetName }}</div>
            </div>
            <div
              class="w-100"
              :class="{ 'mb-3': !fieldRequired.isMenuNameRequire }"
            >
              <label class="fw-bold" for=""
                >New Menu Name
                <span class="text-danger">*</span>
              </label>
              <material-input
                v-model="duplicateMenuset.name"
                type="text"
                id="duplicate_menuset_name"
                name="duplicate_menuset_name"
                placeholder="Enter name"
              />
            </div>
            <div class="w-100 mb-3">
              <span class="is-invalid" v-if="fieldRequired.isMenuNameRequire"
                >The field is required.</span
              >
            </div>
            <div class="w-100 mb-3">
              <label class="fw-bold" for="">Assign To Sales Channel</label>
              <Multiselect
                v-model="duplicateMenuset.branch_ids"
                mode="tags"
                :close-on-select="false"
                :searchable="true"
                :options="branches"
                placeholder="Select sales channel"
                :canClear="true"
              />
            </div>
            <div class="w-100 note-duplicate">
              <div>
                The copy is added to the sales channels you pick. Menu sets
                already assigned there keep serving as they do now.
              </div>
              <div class="mt-1">
                Copied items get a new Item No (the current number with a -2
                suffix). Everything else, barcode included, is copied as it is.
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex mt-3">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                :disabled="isDuplicating"
                @click="duplicate()"
              >
                Duplicate
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background"
                :disabled="isDuplicating"
                @click="closeModal()"
              >
                Cancel
              </material-button>
            </div>
          </div>
          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MenusetService from "../services/product/menuset.service";
import Multiselect from "@vueform/multiselect";
import { scrollToFirstInvalid } from "@/config/utils";

export default {
  name: "duplicate-menuset",
  components: {
    MaterialInput,
    MaterialButton,
    MaterialLoading,
    MaterialSnackbar,
    Multiselect,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    menusetId: {
      type: Number,
      default: 0,
    },
    menusetName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      fieldRequired: {},
      loaderActive: false,
      isDuplicating: false,
      branches: [],
      duplicateMenuset: {
        name: "",
        branch_ids: [],
      },
    };
  },
  methods: {
    getBranches() {
      MenusetService.getBranchs().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branches = response.data.data.branchSelect;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },

    duplicate() {
      if (!this.processValidate() || this.isDuplicating) {
        return;
      }

      // Copying a large menu set takes a few seconds; a second click would create a second copy.
      this.isDuplicating = true;
      this.showLoader();

      MenusetService.duplicate({
        set_id: this.menusetId,
        name: this.duplicateMenuset.name,
        branch_ids: this.duplicateMenuset.branch_ids,
      }).then(
        (response) => {
          this.isDuplicating = false;
          this.hideLoader();

          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.$emit("duplicated", data.menuset.id, this.summaryOf(data));
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.isDuplicating = false;
          this.hideLoader();
          this.snackbar = "danger";
          this.message =
            error.response?.data?.result?.message ?? error.message ?? error;
          this.setTimeOutNotification();
        }
      );
    },

    /** What the merchant gets told was copied, kept to what they can see on the screen. */
    summaryOf(data) {
      const copied = data.copied ?? {};

      return (
        'Duplicated to "' +
        data.menuset.name +
        '": ' +
        (copied.category ?? 0) +
        " categories, " +
        (copied.item ?? 0) +
        " items"
      );
    },

    resetRequired() {
      this.fieldRequired.isMenuNameRequire = false;
    },

    processValidate() {
      this.resetRequired();

      if (
        this.duplicateMenuset.name == "" ||
        this.duplicateMenuset.name == null
      ) {
        this.fieldRequired.isMenuNameRequire = true;
        scrollToFirstInvalid();
        return false;
      }

      return true;
    },

    closeModal() {
      if (this.isDuplicating) {
        return;
      }

      this.$emit("close-duplicate-menuset");
    },

    clearData() {
      this.resetRequired();
      this.isDuplicating = false;
      this.duplicateMenuset = {
        name: this.menusetName ? this.menusetName + " (Copy)" : "",
        branch_ids: [],
      };
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.clearData();
      this.getBranches();
    },
  },
};
</script>
<style scoped>
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.source-name {
  padding-top: 6px;
  font-size: 14px;
}

.note-duplicate {
  font-size: 12px;
  color: #7b809a;
}
</style>
